import React, { Component, PropTypes } from 'react';
import TextArea from '../../textarea';

class ProductInfoModal extends Component {

  render() {
    const { value, _updateSubField } = this.props;
    return (
      <div>
        <div className="form-line">
          <span>Standard Inclusions</span>
          <TextArea
            style={{ resize: 'none' }}
            maxRows={2}
            value={value && typeof value === 'object' ? value.include : ''}
            valueToCheck={value}
            error={(() => {
              if (value) {
                if (value.include) return undefined;
              }
              return 'Required Field';
            })()}
            onChange={({ target: { value: input } }) => _updateSubField('include', input)}
            required
          />
        </div>
        <div className="form-line">
          <span>Standard Exclusions</span>
          <TextArea
            style={{ resize: 'none' }}
            maxRows={2}
            value={value && typeof value === 'object' ? value.exclude : ''}
            valueToCheck={value}
            error={(() => {
              if (value) {
                if (value.exclude) return undefined;
              }
              return 'Required Field';
            })()}
            onChange={({ target: { value: input } }) => _updateSubField('exclude', input)}
            required
          />
        </div>
        <div className="form-line">
          <span>What To Bring</span>
          <TextArea
            style={{ resize: 'none' }}
            maxRows={2}
            value={value && typeof value === 'object' ? value.whatToBring : ''}
            valueToCheck={value}
            error={(() => {
              if (value) {
                if (value.whatToBring) return undefined;
              }
              return 'Required Field';
            })()}
            onChange={({ target: { value: input } }) => _updateSubField('whatToBring', input)}
            required
          />
        </div>
      </div>
    );
  }
}

ProductInfoModal.propTypes = {
  value: PropTypes.object,
  _updateSubField: PropTypes.func,
};

export default ProductInfoModal;



// WEBPACK FOOTER //
// ./src/app/components/profile/edit-modal/product-info-modal.jsx